module.exports = __webpack_public_path__ + "static/media/stripe_discover.d59ae951.svg";